import React from "react";
import PageTitle from "../PageTitle";
import CampaignBox from "./Home/CampaignBox";

export default class Home extends React.Component {
  render() {
    return (
      <div>
        <PageTitle title="Dashboard" bread="Campaigns" />
        <div className="wrapper wrapper-content">
          <CampaignBox />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Pages/Home.jsx